module.exports = __webpack_public_path__ + "img-dashboard/register/web-cv-wonosari.08ace513.png";